module.exports = __webpack_public_path__ + "img/devis-button.9bd9d02a.png";